import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-535f743e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "ステータス", -1))

import { ref, withDefaults, watch } from "vue";
import BaseModal from "@/components/common/BaseModal.vue";
import Select from "@/components/common/form/Select.vue";
import Btn from "@/components/common/Btn.vue";
import Loading from "@/components/common/Loading.vue";
import CompanyInvoiceApi from "@/api/company-invoice";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  visible: boolean;
  headerText?: string;
  onClose?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeStatusModal',
  props: {
    companyInvoice: {},
    visible: { type: Boolean, default: false },
    headerText: {},
    onClose: { type: Function, default: () => {
    return;
  } }
  },
  emits: ["update:companyInvoice"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const isLoading = ref(false);

const status = ref(props.companyInvoice.status);

watch(
  () => props.companyInvoice,
  (newValue) => {
    status.value = newValue.status;
  }
);

const statusOptions =  [
  { label: '取引担当者確認中', value: 'checking' },
  { label: 'イレギュラー', value: 'irregular' },
  { label: 'freeeに発行済み', value: 'billed' },
];

const onSubmit = async () => {
  if (isLoading.value) return;

  isLoading.value = true;

  await CompanyInvoiceApi.updateStatus(
    props.companyInvoice.id,
    status.value
  ).then(() => {
    location.reload();
  });

  isLoading.value = false;

  props.onClose && props.onClose();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "header-text": "ステータスを変更",
    visible: _ctx.visible,
    "on-close": _ctx.onClose
  }, {
    footer: _withCtx(() => [
      _createVNode(Btn, {
        text: "キャンセル",
        "btn-type": "btn-gray",
        "on-click-event": _ctx.onClose,
        class: "cancel-btn"
      }, null, 8, ["on-click-event"]),
      _createVNode(Btn, {
        text: "決定",
        "btn-type": "btn-primary",
        "on-click-event": onSubmit,
        class: "submit-btn",
        disabled: isLoading.value
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      (isLoading.value)
        ? (_openBlock(), _createBlock(Loading, {
            key: 0,
            "is-loading": isLoading.value,
            "is-fixed": ""
          }, null, 8, ["is-loading"]))
        : _createCommentVNode("", true),
      _createVNode(Select, {
        modelValue: status.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event)),
        options: statusOptions,
        placeholder: "ステータスを選択してください"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["visible", "on-close"]))
}
}

})